var map = {
	"./emoticon-csat-1-off.svg": "a73c",
	"./emoticon-csat-2-off.svg": "bf3e",
	"./emoticon-csat-3-off.svg": "faa5",
	"./emoticon-csat-4-off.svg": "feb2",
	"./emoticon-csat-5-off.svg": "ce29",
	"./emoticon-nps-0-off.svg": "05a5",
	"./emoticon-nps-1-off.svg": "c407",
	"./emoticon-nps-10-off.svg": "e97e",
	"./emoticon-nps-2-off.svg": "1f6b",
	"./emoticon-nps-3-off.svg": "3523",
	"./emoticon-nps-4-off.svg": "b8de",
	"./emoticon-nps-5-off.svg": "056b",
	"./emoticon-nps-6-off.svg": "be88",
	"./emoticon-nps-7-off.svg": "fa40",
	"./emoticon-nps-8-off.svg": "f502",
	"./emoticon-nps-9-off.svg": "ba06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44e5";